export default "__VITE_ASSET__9TFAH$UJ__"